var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4995_34391)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 24,
    fill: "#0061FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.292 36.9902L49.0753 22.7734L41.7671 54.7439L33.9508 46.9276L22.7783 64.1812L79.1543 120.557L114.101 84.7817L64.2493 34.9296L63.292 36.9902Z",
    fill: "#004FCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9264 46.5215H23.8639C23.0298 46.5215 22.3535 47.1977 22.3535 48.0319V63.1361C22.3535 63.9702 23.0298 64.6465 23.8639 64.6465H32.9264C33.7606 64.6465 34.4368 63.9702 34.4368 63.1361V48.0319C34.4368 47.1977 33.7606 46.5215 32.9264 46.5215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1354 34.4375H54.0729C53.2387 34.4375 52.5625 35.1137 52.5625 35.9479V63.1354C52.5625 63.9696 53.2387 64.6458 54.0729 64.6458H63.1354C63.9696 64.6458 64.6458 63.9696 64.6458 63.1354V35.9479C64.6458 35.1137 63.9696 34.4375 63.1354 34.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0309 22.3555H38.9684C38.1342 22.3555 37.458 23.0317 37.458 23.8659V63.1367C37.458 63.9709 38.1342 64.6471 38.9684 64.6471H48.0309C48.8651 64.6471 49.5413 63.9709 49.5413 63.1367V23.8659C49.5413 23.0317 48.8651 22.3555 48.0309 22.3555Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4995_34391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.bd88d3c4061b6045802047784cc7509c.svg";
export { ForwardRef as ReactComponent };